import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import IconButton from "../../../../components/IconButton";
import Spinner from "../../../../components/Spinner";
import useAuthData from "../../../../hook/useAppData";
import { IconCalendarWithPencil, IconLeftArrowVersion2 } from "../../../../icons";
import { dateFromInitial, dateToInitial, convertDate } from "../../../../libs/dateUtils";
import { PointsByDayRange } from "../../model";
import { getPointsByDayRange } from "../../service";
import { TitleMobile } from "../components/TitleMobile";
import { TimeSheetFilterMobile } from "./FilterMobile";
import { HistoryDetailsMobile } from "./HistoryDetailsMobile";
import { HistoryEditMobile } from "./HistoryEditMobile";
import HistoryPointsMobile from "./HistoryPointsMobile";
import "./index.scss";

export type TypePages = "history" | "filter" | "details";

export function TimeSheetHistoryMobile() {
  const { token, userId } = useAuthData();
  const history = useHistory();
  const [pages, setPages] = useState<TypePages>("history");
  const [dateFrom, setDateFrom] = useState(dateFromInitial);
  const [dateTo, setDateTo] = useState(dateToInitial);
  const [points, setPoints] = useState<PointsByDayRange[]>();
  const [needSpinner, setNeedSpinner] = useState(true);
  const [dateRow, setDateRow] = useState();

  useEffect(() => {
    getPointsRange(dateFrom, dateTo);
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 500);
  }, [points]);

  async function getPointsRange(dateFrom: string, dateTo: string) {
    const dataReq: PointsByDayRange[] = await getPointsByDayRange(token, userId, dateFrom, dateTo);
    setPoints(dataReq);
  }

  return (
    <>
      <div className="flex flex-col -m-4 h-full">
        <div className="h-24 w-full">_</div>
        <div className="m-8 flex-col h-full">
          {pages === "history" && <HistoryPointsMobile needSpinner={needSpinner} points={points} setPages={setPages} setDateRow={setDateRow} />}
          {pages === "filter" && (
            <TimeSheetFilterMobile
              setPage={() => setPages("history")}
              dateFrom={dateFrom}
              dateTo={dateTo}
              setDateFrom={setDateFrom}
              setDateTo={setDateTo}
              getPointsRange={getPointsRange}
            />
          )}
          {pages === "details" && <HistoryDetailsMobile setPages={setPages} dateRow={dateRow} />}
        </div>
      </div>
    </>
  );
}
